<template>
  <div class="popup-main">
    <el-dialog
      title="开收款单"
      width="1000px"
      :visible.sync="selfShow"
      :close-on-click-modal="false"
    >
      <div>
        <e-form
          ref="refForm1"
          :config="formConfig"
          :column="formColumn1"
          :data.sync="selfData"
          :rules="rules1"
        />
        <div class="info-list">
          <span class="info-item" v-for="(item, index) in infoPrice" :key="index">
            <span v-if="item.key" class="key">{{ item.key }}</span>
            <span v-if="item.val" class="val">{{ priceObj[item.val] || 0 }}</span>
          </span>
        </div>
        <div v-if="bankObj.bank_name" class="info-list">
          <span class="info-item" v-for="(item, index) in infoBank" :key="index">
            <span class="key">{{ item.key }}</span>
            <span class="val">{{ bankObj[item.val] }}</span>
          </span>
        </div>

        <e-form
          ref="refForm2"
          :config="formConfig"
          :column="formColumn2"
          :data.sync="selfData"
          :rules="rules2"
        />
      </div>
      <div slot="footer">
        <el-button size="mini" @click="popupCancel">取消</el-button>
        <el-button size="mini" type="primary" @click="popupPush(false)">提交</el-button>
        <el-button size="mini" type="primary" @click="popupPush(true)">打印</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      required: true
    },
    companyName: {
      type: String,
      required: true
    },
    billId: {
      type: [Number, String],
      required: true
    }
  },
  data() {
    return {
      selfShow: false,
      selfData: {
        company_name: this.companyName,
        bill_id: this.billId,
        bill_type: '收款单',
        bank_name: '',
        bank_id: '',
        collection_type: '',
        amount_received: '',
        ke_mu: '',
        remark: '',
        cash_photo_list: []
      },
      formConfig: {
        width: '50%'
      },
      formColumn1: [
        {
          type: 'select',
          title: '关联客户',
          field: 'company_name',
          required: true,
          options: [],
          remote: true,
          remoteMethod: (val) => {
            this.getCompanyList(val)
          }
        },
        {
          type: 'select',
          title: '关联订单',
          field: 'bill_id',
          required: true,
          options: []
        }
      ],
      rules1: {
        company_name: [{ required: true, message: '请选择关联客户' }],
        bill_id: [{ required: true, message: '请选择关联订单' }]
      },
      formColumn2: [
        {
          type: 'select',
          title: '收款账户',
          field: 'bank_name',
          required: true,
          options: [],
          fnChange: () => {
            this.setBank()
          }
        },
        {
          type: 'select',
          title: '收款类型',
          field: 'collection_type',
          required: true,
          options: [
            {
              key: '定金',
              val: '定金'
            },
            {
              key: '尾款',
              val: '尾款'
            },
            {
              key: '全款',
              val: '全款'
            }
          ]
        },
        {
          type: 'text',
          title: '收款金额(元)',
          field: 'amount_received',
          required: true
        },
        {
          type: 'text',
          title: '收入科目',
          field: 'ke_mu'
        },
        {
          type: 'text',
          title: '备注',
          field: 'remark'
        },
        {
          type: 'upload_image',
          title: '客户付款凭证',
          field: 'cash_photo_list',
          isDelete: true,
          size: '28px'
        }
      ],
      rules2: {
        bank_name: [{ required: true, message: '请选择收款账户' }],
        collection_type: [{ required: true, message: '请选择收款类型' }],
        amount_received: [{ required: true, message: '请输入收款金额' }]
      },
      companyList: [],
      orderList: [],
      bankList: [],
      priceObj: {},
      defaultPriceObj: {
        lei_ji_song_huo: 0,
        lei_ji_shou_kuan: 0,
        ke_hu_qian_kuan: 0
      },
      bankObj: {},
      infoPrice: [
        { key: '累计送货(元)', val: 'lei_ji_song_huo' },
        { key: '累计收款(元)', val: 'lei_ji_shou_kuan' },
        { key: '客户欠款(元)', val: 'ke_hu_qian_kuan' },
        { key: '', val: '' }
      ],
      infoBank: [
        { key: '账户简称', val: 'bank_short_name' },
        { key: '收款单位', val: 'bank_company' },
        { key: '银行账号', val: 'bank_code' },
        { key: '收款银行', val: 'bank_name' }
      ]
    }
  },
  watch: {
    selfShow(val) {
      this.$emit('update:show', val)
    },
    'selfData.company_name': {
      handler(newVal, oldVal) {
        if (newVal && newVal !== oldVal) this.getOrderList()
      },
      deep: true,
      immediate: true
    },
    'selfData.bill_id': {
      handler(newVal, oldVal) {
        if (newVal && newVal !== oldVal) this.getPriceData()
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    this.selfShow = this.show
    this.getCompanyList()
    this.getBankList()
    this.priceObj = this.$util.deepCopy(this.defaultPriceObj)
  },
  methods: {
    // 获取客户列表
    getCompanyList(keyword = '') {
      this.$api({
        method: 'post',
        url: '/admin/customers/search',
        data: {
          keyword,
          pageSize: 200
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          let result = this.$util.deepCopy(res.data.page.list)
          this.companyList = result
          this.formColumn1.forEach((formItem) => {
            if (formItem.field === 'company_name') {
              formItem.options = this.companyList.map((customerItem) => {
                return {
                  key: customerItem.customer_name,
                  val: customerItem.customer_name
                }
              })
            }
          })
        }
      })
    },
    // 获取订单列表
    getOrderList() {
      this.$api({
        method: 'get',
        url: '/admin/gcvip/reportBill/searchCodeByCompanyName',
        params: {
          company_name: this.selfData.company_name
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          let result = this.$util.deepCopy(res.data.list)
          this.orderList = result
          this.formColumn1.forEach((formItem) => {
            if (formItem.field === 'bill_id') {
              formItem.options = this.orderList.map((orderItem) => {
                return {
                  key: orderItem.bill_code,
                  val: orderItem.id
                }
              })

              let hasBillId = formItem.options.some(
                (orderItem) => orderItem.val === this.selfData.bill_id
              )
              if (formItem.options.length) {
                if (!hasBillId) this.selfData.bill_id = formItem.options[0].val
              } else {
                this.selfData.bill_id = ''
                this.priceObj = this.$util.deepCopy(this.defaultPriceObj)
              }
            }
          })
        }
      })
    },
    // 获取收款账号列表
    getBankList() {
      this.$api({
        method: 'post',
        url: '/admin/gcvip/bank/list',
        data: {
          currentPage: 1,
          pageSize: this.$constant.pageMax,
          sortData: {
            id: 'desc'
          }
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          this.bankList = this.$util.deepCopy(res.data.page.list)
          this.formColumn2.forEach((formItem) => {
            if (formItem.field === 'bank_name') {
              formItem.options = this.bankList.map((bankItem) => {
                return {
                  key: bankItem.bank_name,
                  val: bankItem.bank_name
                }
              })
            }
          })
        }
      })
    },
    // 获取价格数据
    getPriceData() {
      this.$api({
        method: 'get',
        url: '/admin/gcvip/reportBill/leiji',
        params: {
          id: this.selfData.bill_id
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          this.priceObj = this.$util.deepCopy(res.data.data)
        }
      })
    },

    // 设置收款
    setBank() {
      if (!this.selfData.bank_name) this.bankObj = {}
      this.bankList.forEach((item) => {
        if (item.bank_name === this.selfData.bank_name) {
          this.selfData.bank_id = item.id
          this.bankObj = this.$util.deepCopy(item)
        }
      })
    },
    // 项-打印
    popupPrint(id) {
      window.open(`/finance/payin/print?id=${id}`, '_blank')
    },
    // 弹窗取消
    popupCancel() {
      this.selfShow = false
      this.$emit('update:show', false)
    },
    // 弹窗确认
    popupPush(isPushAndPrint) {
      this.$refs.refForm1.$refs.refForm.validate((valid1) => {
        if (valid1) {
          this.$refs.refForm2.$refs.refForm.validate((valid2) => {
            if (valid2) {
              this.$api({
                method: 'post',
                url: '/admin/gcvip/reportBill/saveOrUpdateByCash',
                data: this.selfData
              })
                .then((res) => {
                  if (res.data.state === 'ok') {
                    this.popupCancel()
                    this.$emit('success')
                    this.$message.success('保存成功')
                    if (isPushAndPrint) this.popupPrint(res.data.id)
                  }
                })
                .catch((error) => {
                  this.$message.error(error)
                })
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.popup-main {
  .info-list {
    display: flex;
    width: 930px;
    padding: 10px;
    margin-bottom: 10px;
    background: @colorGreen10;
    border-radius: 4px;
    & ~ .info-list {
      background: @colorBlue10;
    }
    .info-item {
      flex: 1;
      display: flex;
      flex-direction: column;
      & ~ .info-item {
        margin-left: 10px;
      }
      .key {
        color: @colorGrayDeep;
      }
      .val {
        margin-top: 5px;
        color: @colorGrayLight;
      }
    }
  }
}
</style>
